export const spacing = {
  0: 0,
  0.5: 2,
  1: 4,
  1.5: 6,
  2: 8,
  2.5: 10,
  3: 12,
  3.5: 14,
  4: 16,
  5: 20,
  6: 24,
  7: 28,
  8: 32,
  9: 36,
  10: 40,
  11: 44,
  12: 48,
  14: 56,
  16: 64,
  20: 80,
  24: 96,
  28: 112,
  32: 128,
  36: 144,
  38: 152,
  40: 160,
  42: 168,
  44: 176,
  45: 180,
  46: 184,
  48: 192,
  52: 208,
  56: 224,
  60: 240,
}
export type TSpace = keyof typeof spacing
